export enum KeepAliveModalClosedReason {
    EXPIRED,
    DECLINED,
    ACCEPTED
}
